import routeSeoData from './routeSeoData';

const {
  DEFAULT_IMAGE,
  DEFAULT_ROBOTS,
  ROUTE_SEO,
  SITE_URL,
} = routeSeoData;

export const getRouteSeo = (path) => {
  const route = ROUTE_SEO[path];
  if (!route) return null;
  return {
    ...route,
    canonicalPath: path,
    image: route.image || DEFAULT_IMAGE,
    robots: route.robots || DEFAULT_ROBOTS,
    type: route.type || 'website',
  };
};

export {
  DEFAULT_IMAGE,
  DEFAULT_ROBOTS,
  ROUTE_SEO,
  SITE_URL,
};
